import { render, staticRenderFns } from "./ManageCcpItemFieldsPopUp.vue?vue&type=template&id=5db7a9ce&scoped=true&"
import script from "./ManageCcpItemFieldsPopUp.vue?vue&type=script&lang=js&"
export * from "./ManageCcpItemFieldsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ManageCcpItemFieldsPopUp.vue?vue&type=style&index=0&id=5db7a9ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7a9ce",
  null
  
)

export default component.exports